import { Link } from 'react-router';

export interface WhyArchiProCardProps {
    title: string;
    icon?: React.ReactNode;
    description: string;
    to?: string;
    buttonText?: string;
}

const WhyArchiProCard = (props: WhyArchiProCardProps) => {
    const { title, description, to, buttonText, icon } = props;
    return (
        <div className="flex flex-col gap-5 border-t border-gray-200 pt-3">
            <div className="flex h-10.5 w-10.5 items-center justify-center rounded-full bg-brick-200">
                {icon}
            </div>

            <div className="flex flex-col gap-7.5">
                <div className="flex flex-col">
                    <div className="inline pb-4 text-lg leading-[130%] tracking-[0.025rem] md:pb-0 md:pr-16">
                        <h3 className="inline font-medium">{`${title} - `}</h3>
                        {description}
                    </div>
                </div>
                {to && (
                    <Link
                        to={to}
                        className="w-fit text-base font-medium"
                        style={{
                            textDecoration: 'underline',
                            textUnderlineOffset: '0.5rem',
                        }}
                    >
                        {buttonText}
                    </Link>
                )}
            </div>
        </div>
    );
};

export default WhyArchiProCard;
